import { Header } from "@/components/common/header/Header"
import { CommonInput } from "@/components/common/element/fields/CommonInput"
import Button from "@/ui/components/Button"

import * as TrinityAPI from "@/requests/TrinityAPI"

import { MenuAdmin } from "../MenuAdmin"
import { AdminFloatingRates } from "./floatingRate/AdminFloatingRates"

import { useEffect, useState, type FC } from "react"

import type { BaseSettings } from "./types"
import type { IErrorModel } from "@/types/error/IErrorModel"

import style from "./style.module.scss"

export const RateSettings: FC = () => {
  const [isSaving, setSaving] = useState(false)
  const [settings, setSettings] = useState<BaseSettings>()
  const [errors] = useState<IErrorModel>()

  const getData = () => {
    TrinityAPI.getBaseSettings().then(response => {
      setSettings({
        ...response.data,
        swiftAmount: response.data.swiftAmount ? Number(response.data.swiftAmount / 100) : 0,
        inquiryAmount: response.data.inquiryAmount ? Number(response.data.inquiryAmount / 100) : 0
      })
    })
  }

  const onSave = () => {
    if (isSaving || !settings) {
      return
    }

    setSaving(true)

    const payload = {
      baseRate: Number(settings.baseRate),
      inquiryAmount: Number(settings.inquiryAmount) * 100,
      swiftAmount: Number(settings.swiftAmount) * 100
    }

    TrinityAPI.createBaseSettings(
      payload,
      response => {},
      () => setSaving(false)
    )
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <>
      <MenuAdmin active={"rate-settings"} />
      <section className="new-contragent">
        <Header />
        <div className="container">
          <h3 className="ui-heading">Общие настройки системы</h3>
          <div className="container-pop-up">
            <div className={style.wrapper}>
              <div className={style.content}>
                <div className="form-block-popup">
                  <h4 className="heading-chapter">Базовые ставки</h4>
                  <CommonInput
                    typeName={"text"}
                    label={"Стоимость SWIFT"}
                    placeholder={"Сумма"}
                    name={"swiftAmount"}
                    value={settings?.swiftAmount}
                    errorModel={errors}
                    _callback={e => setSettings({ ...settings, swiftAmount: e })}
                  />
                  <CommonInput
                    typeName={"text"}
                    label={"Стоимость расследования"}
                    placeholder={"Сумма"}
                    name={"inquiryAmount"}
                    value={settings?.inquiryAmount}
                    errorModel={errors}
                    _callback={e => setSettings({ ...settings, inquiryAmount: e })}
                  />
                  <CommonInput
                    typeName={"text"}
                    label={"Базовая ставка"}
                    placeholder={"Сумма"}
                    name={"baseRate"}
                    value={settings?.baseRate}
                    errorModel={errors}
                    _callback={e => setSettings({ ...settings, baseRate: e })}
                  />

                  <Button className={style.saveButton} loading={isSaving} onClick={onSave}>
                    Сохранить
                  </Button>
                </div>

                <div>
                  <AdminFloatingRates />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
